export const SET_ASSETS_PATH = "SET_ASSETS_PATH";

export function setAssetsPath(path) {
  return {
    type: SET_ASSETS_PATH,
    assetsUrl: path,
  };
}
